"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.norwayTranslations = void 0;
var _types = require("../../../types");
const norwayTranslations = exports.norwayTranslations = {
  [_types.ErrorPageTranslationKey.headline]: ' Vi beklager! ',
  [_types.ErrorPageTranslationKey.buttonText]: ' Tilbake',
  [_types.ErrorPageTranslationKey.text]: ' Nettsiden er for øyeblikket ikke tilgjengelig',
  [_types.ErrorPageTranslationKey.notFound]: 'Siden du leter etter finnes dessverre ikke',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Siden du prøver å nå har begrensninger og alle kriteriene ble ikke oppfylt.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Vennligst kontakt Oriflame-støtteteamet via e-post:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Den forespurte nettadressen ble avvist!'
};
